@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@file-status-label-border-radius: 2px;

.status-label-mixin(@primaryColor; @secondaryColor) {
  .pill {
    background: @primaryColor;
    border-color: @primaryColor;
  }

  .status-text {
    background: @secondaryColor;
  }
}

.status-label-wrapper {
  display: inline-flex;
  align-content: center;
  background-color: @file-status-label--background-color;
  border-radius: @file-status-label-border-radius;
  height: 24px;
  font-size: 12px;
  border: 1px solid @file-status-label--success--background-color;

  & > * {
    display: flex;
    align-items: center;
    padding: 0 8px;
    border-top: 1px solid @file-status-label--border-color;
    border-bottom: 1px solid @file-status-label--border-color;

    &:first-child {
      border-left: 1px solid @file-status-label--border-color;
      border-top-left-radius: @file-status-label-border-radius;
      border-bottom-left-radius: @file-status-label-border-radius;
    }

    &:last-child {
      border-right: 1px solid @file-status-label--border-color;
      border-top-right-radius: @file-status-label-border-radius;
      border-bottom-right-radius: @file-status-label-border-radius;
    }
  }
}

.pill {
  width: 8px;
  padding: 0;
}

.status-text {
  border-right: 1px solid @file-status-label--border-color;
  font-weight: @normal;
  white-space: nowrap;
}

.neutral {
  .status-label-mixin(
    @file-status-label--neutral--background-color,
    @file-status-label--neutral--text-color
  );
}

.success {
  .status-label-mixin(
    @file-status-label--success--background-color,
    @file-status-label--success--text-color
  );
}

.warning {
  .status-label-mixin(
    @file-status-label--warning--background-color,
    @file-status-label--warning--text-color
  );
}
